import { AdminBookingFormDialog } from '~/ui/Dialogs/BookingFormDialog/AdminBookingForm';
import { MobileLogin } from '../Dialogs/MobileLogin/MobileLogin';
export default {
    book: {
        component: AdminBookingFormDialog,
        props: {
            showCloseButton: false,
        },
        responsiveProps: {
            dialogProps: {
                md: {},
                xs: {
                    footerButtonGroupProps: {
                        width: "100%",
                    }
                }
            },
            closeButtonProps: {
                md: {},
                xs: {
                    label: null,
                    iconSize: 'sm',
                    icon: "arrow-back",
                    containerProps: {
                        mr: 'auto',
                    }
                }
            }
        }
    },
    mobile_login: {
        component: MobileLogin,
        props: {
            type: "extra-small"
        }
    },
};